import Component from '../core/Component';
import { loadComponents } from '../core/componentUtils';

export default class Cloner extends Component {

    constructor($element) {
        super($element);
        this.$add = $element.find('[data-cloner-action="Add"]');
        this.$remove = $element.find('[data-cloner-action="Remove"]');
        this.template = $element.find('[data-cloner-template]')[0].outerHTML;
        $element.find('[data-cloner-template]').remove();
        this.$items = $element.find('[data-cloner-item]');
        //this.index = $element.data('cloner-start-index');
    }

    prepare() {
        var self = this;
        this.$add
            .on('click', () => {
            var $new = this.$items.eq(this.$items.length - 1).after(this.createElement());
            this.$items = this.$element.find('[data-cloner-item]');
            this.$remove = this.$element.find('[data-cloner-action="Remove"]');
            this.$items.eq(this.$items.length - 1).find('[data-cloner-action="Remove"]').on('click', function (event) {
                event.preventDefault();
                self.$items = self.$element.find('[data-cloner-item]');
                self.$remove = self.$element.find('[data-cloner-action="Remove"]');
                $(this).parents('[data-cloner-item]').remove();
            });
            loadComponents($new.parent());
        });
        this.$remove
            .on('click', function (event) {
                event.preventDefault();
                self.$items = self.$element.find('[data-cloner-item]');
                self.$remove = self.$element.find('[data-cloner-action="Remove"]');
                $(this).parents('[data-cloner-item]').remove();
        });
    }

    createElement () {
        var html = this.template;
        //html = html.replace("<cloner_id>", this.index);
        html = html.replace("data-cloner-template", "data-cloner-item");
        //this.index++;
        return html;
    }
}


// WEBPACK FOOTER //
// ./components/Cloner.js